"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @uifabric/foundation@0.8.2
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
var set_version_1 = require("@uifabric/set-version");
set_version_1.setVersion('@uifabric/foundation', '0.8.2');
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/foundation/lib-commonjs/version.js
// module id = 1045
// module chunks = 0